import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import styles from "./Modal.module.scss"

class Modal extends React.Component {
  render() {
    return (
      <Dialog
        maxWidth={'md'}
        fullWidth={this.props.fullWidth}
        open={this.props.open}
        aria-labelledby="scroll-dialog-title"
      >
        <DialogTitle id="scroll-dialog-title">{this.props.title}</DialogTitle>
        <DialogContent classes={{ root: this.props.fixedHeight ? styles.modal : null }}>{this.props.children}</DialogContent>
        <DialogActions>{this.props.actions}</DialogActions>
      </Dialog>
    );
  }
}

export default Modal;
